import script from "./AddNews.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNews.vue?vue&type=script&setup=true&lang=js"

import "./AddNews.vue?vue&type=style&index=0&id=70c56d0c&lang=css"
import "./AddNews.vue?vue&type=style&index=1&id=70c56d0c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70c56d0c"]])

export default __exports__